module.exports = __webpack_public_path__ + "static/media/logo.14b25957.svg";